import { Configuration } from "vmd-types";

import { STRAPI_URL } from "../env";
import {
  appQueryClient,
  fetchWithCache,
  invalidateAppQueries,
} from "./query-cache";

export async function fetchEntityConfiguration(): Promise<
  Configuration | undefined
> {
  return fetchWithCache({
    queryKey: ["entity-configuration"],
    staleTime: 15 * 60 * 1000,
    fallback: appQueryClient.getQueryData<Configuration>([
      "entity-configuration",
    ]),
    queryFn: async () => {
      const response = await fetch(`${STRAPI_URL}/configuration`, {
        credentials: "include",
      });

      if (response.status >= 400) {
        throw new Error(`Fetch failed with status ${response.status}.`);
      }

      return (await response.json()) as Configuration;
    },
  });
}

export async function createConfiguration(
  configuration: Configuration
): Promise<Configuration | undefined> {
  try {
    const response = await fetch(`${STRAPI_URL}/configuration`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(configuration),
    });

    if (response.status >= 400) {
      throw new Error(`Fetch failed with status ${response.status}.`);
    }
    await invalidateAppQueries(["entity-configuration"]);
    await invalidateAppQueries(["settings"]);
    await invalidateAppQueries(["dashboard"]);
    await invalidateAppQueries(["overview"]);
    await invalidateAppQueries(["overlay"]);

    const json = (await response.json()) as Configuration;

    return json;
  } catch {
    return;
  }
}
